(function () {
  if (window.__textAtcSync) return; window.__textAtcSync = true;

  function getCurrentVariantId() {
    const other = document.querySelector('form[action^="/cart/add"] input[name="id"]:not([data-text-atc-variant-input])');
    if (other && other.value) return other.value;
    const sel = document.querySelector('select[name="id"] option:checked');
    if (sel && sel.value) return sel.value;
    return null;
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-text-atc-submit]');
    if (!btn) return;
    const formId = btn.getAttribute('data-text-atc-submit');
    const form = document.getElementById(formId);
    if (!form) return;
    const hidden = form.querySelector('[data-text-atc-variant-input]');
    if (!hidden) return;

    const v = getCurrentVariantId();
    if (v) hidden.value = v;
  }, { capture: true });

  ['variant:change','product:variant-change','theme:variant:change'].forEach(function (name) {
    document.addEventListener(name, function (ev) {
      var d = ev.detail || {};
      var vId = (d.variant && (d.variant.id || d.id)) || d.variantId || d.id;
      if (!vId) return;
      document.querySelectorAll('[data-text-atc-variant-input]').forEach(function (inp) {
        inp.value = vId;
      });
    });
  });
})();
